import { COLOR, FONT_SIZE } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";

export const DivContainer = styled.div`
  position: fixed;
  display: flex;
  align-items: center;
  left: 0;
  bottom: 0;
  width: 100%;
  height: calc(45px + env(safe-area-inset-bottom));
  background-color: ${COLOR.GRAY100.code};
  padding: var(--sat) var(--sar) var(--sab) var(--sal);
  border-top: 1px solid ${COLOR.GRAY200.code};
`;

export const ULWrapper = styled.ul`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const LIList = styled.li<{ isActive?: boolean }>`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: ${COLOR.GRAY1000.code};
  opacity: 0.6;
  ${({ isActive }) => isActive && `border-bottom: 2px solid ${COLOR.YELLOW900.code}; opacity: 1;`}
`;

export const AnchorItem = styled.a`
  font-size: ${FONT_SIZE.XXS}px;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  width: 100%;
`;
